module.exports = __webpack_public_path__ + "img/en-lang.d2adc7ae.svg";